import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/single-door-fridge-service-bangalore", label: "Single Door Service" },
  { to: "/double-door-refrigerator-service-bangalore", label: "Double Door Service" },
  { to: "/fridge-not-cooling-repair", label: "Fridge Not Cooling" },
  { to: "/freezer-cooling-issue", label: "Freezer Cooling Issue" },
];

const FridgeWaterLeakRepair = () => {
  return (
    <FridgePageTemplate
      title="Fridge Water Leak Repair in Bangalore"
      description="Expert refrigerator water leak repair in Bangalore for hose, drain, gasket, and valve issues."
      keywords="fridge water leak repair bangalore, refrigerator leak repair bangalore, fridge leak service"
      path="/fridge-water-leak-repair"
      bannerTitle="Fridge Water Leak Repair"
      intro={
        <>
          If your fridge is leaking water, our Bangalore technicians can locate the source and repair hoses, seals, drains, and valves to stop damage and restore proper operation.
        </>
      }
      highlights={[
        "Hose and drain blockage repair",
        "Door seal and gasket replacement",
        "Water valve and pump checks",
        "Fast home service for fridge leaks",
      ]}
      issues={[
        "Water pooling around the fridge",
        "Leaks from the drain pan",
        "Door seal and gasket failure",
        "Overflow during defrost cycle",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default FridgeWaterLeakRepair;

